import i18n from "../i18n";

export const UserRole = {
  admin: "admin",
  manager: "manager",
  waiter: "waiter",
  client: "client",
};

export const UserModel = {
  fullName: "",
  email: "",
  role: UserRole.client,
  restaurants: [],
};

export const UserRoleList = [
  { _id: UserRole.admin, label: "Administrateur", labelKey: "roles.admin" },
  { _id: UserRole.manager, label: "Gérant", labelKey: "roles.manager" },
  { _id: UserRole.waiter, label: "Serveur", labelKey: "roles.waiter" },
  { _id: UserRole.client, label: "Client", labelKey: "roles.client" },
];

export const BlockList = [
  { _id: false, label: "Utilisateur actif", labelKey: "common.unblocked" },
  { _id: true, label: "Utilisateur bloqué", labelKey: "common.blocked" },
];

export const getUserRoleLabel = (role) => {
  const key = `roles.${role}`;
  const label = i18n.t(key);
  return label === key ? role : label;
};
